import React from "react";

export default function ReferralAnimation() {
  return (
    <div className="refa-stage">
      <div className="refa-phone-shadow" />

      <div className="refa-phone">
        <div className="refa-phone-glow" />

        <div className="refa-phone-frame">
          <div className="refa-notch" />

          <div className="refa-screen">
            <div className="refa-status">
              <span>9:41</span>
              <div>
                <i />
                <i />
                <b />
              </div>
            </div>

            <SceneGetReferralCode />
            <SceneShareToFriends />
            <SceneFriendTextsZaviramed />
            <SceneFriendEntersCode />
            <SceneFreeConsultationUnlocked />
          </div>
        </div>
      </div>

      <style>{styles}</style>
    </div>
  );
}

function SceneGetReferralCode() {
  return (
    <div className="refa-scene refa-scene-1">
      <div className="refa-app-head">
        <img src="/logo_new_nobg.png" alt="Zaviramed" />
        <div>
          <strong>Zaviramed</strong>
          <span>Referral code</span>
        </div>
      </div>

      <div className="refa-step">Step 1</div>

      <h3>Get your referral code</h3>

      <p className="refa-copy">
        Enter your WhatsApp number and receive your unique Zaviramed referral
        code.
      </p>

      <div className="refa-number-card">
        <small>WhatsApp Number</small>
        <strong>0806 980 4062</strong>
      </div>

      <div className="refa-code-card">
        <small>Your Referral Code</small>
        <strong>ref-45988</strong>
      </div>
    </div>
  );
}

function SceneShareToFriends() {
  return (
    <div className="refa-scene refa-scene-2">
      <div className="refa-wa-header">
        <div className="refa-avatar">F</div>
        <div>
          <strong>Friends & Family</strong>
          <span>WhatsApp</span>
        </div>
      </div>

      <div className="refa-chat-area">
        <div className="refa-bubble right share-1">
          I use Zaviramed to chat with doctors on WhatsApp.
        </div>

        <div className="refa-bubble right share-2">
          Use my referral code when they ask:
          <strong>ref-45988</strong>
        </div>

        <div className="refa-bubble left share-3">
          Thank you. I’ll message Zaviramed now.
        </div>
      </div>

      <div className="refa-compose">
        <span>Message</span>
        <button>➤</button>
      </div>
    </div>
  );
}

function SceneFriendTextsZaviramed() {
  return (
    <div className="refa-scene refa-scene-3">
      <div className="refa-wa-header green">
        <img src="/logo_new_nobg.png" alt="Zaviramed" />
        <div>
          <strong>Zaviramed Doctor</strong>
          <span>online</span>
        </div>
      </div>

      <div className="refa-chat-area doctor-chat">
        <div className="refa-bubble right doctor-1">
          Hello, I want to speak with a doctor.
        </div>

        <div className="refa-bubble left doctor-2">
          Welcome to Zaviramed 👋 Before we continue, do you have a referral
          code?
        </div>
      </div>

      <div className="refa-compose">
        <span>Message</span>
        <button>➤</button>
      </div>
    </div>
  );
}

function SceneFriendEntersCode() {
  return (
    <div className="refa-scene refa-scene-4">
      <div className="refa-wa-header green">
        <img src="/logo_new_nobg.png" alt="Zaviramed" />
        <div>
          <strong>Zaviramed Doctor</strong>
          <span>online</span>
        </div>
      </div>

      <div className="refa-chat-area doctor-chat">
        <div className="refa-bubble left enter-1">
          Please enter your referral code now.
        </div>

        <div className="refa-bubble right enter-2">
          ref-45988
        </div>

        <div className="refa-bubble left enter-3">
          Referral code accepted ✅
        </div>
      </div>

      <div className="refa-credit-float">
        <span>Referral added</span>
        <strong>+0.25 free consultation</strong>
      </div>
    </div>
  );
}

function SceneFreeConsultationUnlocked() {
  return (
    <div className="refa-scene refa-scene-5">
      <div className="refa-rings">
        <span />
        <span />
        <span />
      </div>

      <div className="refa-final-card">
        <img src="/logo_new_nobg.png" alt="Zaviramed" />

        <small>Referral reward</small>

        <h3>Free consultation unlocked</h3>

        <p>
          Once enough friends and family register with your code, your free
          consultation balance goes up automatically.
        </p>

        <div className="refa-balance">
          <span>Free Consultation Balance</span>
          <strong>1.00</strong>
        </div>
      </div>
    </div>
  );
}

const styles = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800;900;1000&family=Sora:wght@400;500;600;700;800&display=swap');

.refa-stage,
.refa-stage * {
  box-sizing: border-box;
  font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.refa-stage {
  position: relative;
  min-height: 650px;
  display: grid;
  place-items: center;
  perspective: 1600px;
}

.refa-phone-shadow {
  position: absolute;
  width: 320px;
  height: 80px;
  bottom: 12px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(15,23,42,.22), transparent 70%);
  filter: blur(18px);
  animation: refaShadow 5s ease-in-out infinite;
}

.refa-phone {
  position: relative;
  width: clamp(292px, 30vw, 334px);
  height: clamp(584px, 60vw, 668px);
  animation: refaPhoneFloat 5.4s ease-in-out infinite;
}

.refa-phone-glow {
  position: absolute;
  inset: -18px;
  border-radius: 64px;
  background: linear-gradient(135deg, rgba(34,197,94,.26), rgba(14,165,233,.18));
  filter: blur(18px);
}

.refa-phone-frame {
  position: absolute;
  inset: 0;
  padding: 11px;
  border-radius: 50px;
  background: linear-gradient(145deg, #030712 0%, #0f172a 52%, #111827 100%);
  box-shadow:
    inset 0 0 0 2px rgba(255,255,255,.08),
    0 44px 120px rgba(15,23,42,.25);
}

.refa-notch {
  position: absolute;
  z-index: 20;
  top: 16px;
  left: 50%;
  width: 98px;
  height: 23px;
  transform: translateX(-50%);
  border-radius: 0 0 18px 18px;
  background: #020617;
}

.refa-screen {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 39px;
  background: #ffffff;
}

.refa-status {
  position: absolute;
  z-index: 30;
  left: 0;
  right: 0;
  top: 0;
  height: 40px;
  padding: 0 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #0f172a;
  font-size: 13px;
  font-weight: 900;
}

.refa-status div {
  display: flex;
  align-items: center;
  gap: 6px;
}

.refa-status i {
  width: 15px;
  height: 10px;
  border-radius: 4px;
  border: 2px solid #0f172a;
  display: block;
}

.refa-status b {
  width: 22px;
  height: 11px;
  border: 2px solid #0f172a;
  border-radius: 4px;
  display: block;
  position: relative;
}

.refa-status b::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  width: 12px;
  height: 3px;
  border-radius: 2px;
  background: #16a34a;
}

.refa-scene {
  position: absolute;
  inset: 0;
  padding: 54px 16px 18px;
  opacity: 0;
  pointer-events: none;
}

.refa-scene-1 {
  background: linear-gradient(180deg, #ecfdf5 0%, #ffffff 72%);
  animation: refaScene1 24s linear infinite;
}

.refa-scene-2 {
  background: #efeae2;
  padding: 40px 0 0;
  animation: refaScene2 24s linear infinite;
}

.refa-scene-3 {
  background: #efeae2;
  padding: 40px 0 0;
  animation: refaScene3 24s linear infinite;
}

.refa-scene-4 {
  background: #efeae2;
  padding: 40px 0 0;
  animation: refaScene4 24s linear infinite;
}

.refa-scene-5 {
  background: linear-gradient(135deg, #052e2b, #064e3b 54%, #0f766e);
  display: grid;
  place-items: center;
  animation: refaScene5 24s linear infinite;
}

.refa-app-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 22px;
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(15,23,42,.08);
  box-shadow: 0 18px 38px rgba(15,23,42,.06);
}

.refa-app-head img {
  width: 42px;
  height: 42px;
  object-fit: contain;
  border-radius: 14px;
  background: #fff;
}

.refa-app-head strong {
  display: block;
  color: #0f172a;
  font-size: 15px;
  font-weight: 900;
}

.refa-app-head span {
  display: block;
  margin-top: 2px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
}

.refa-step {
  margin-top: 28px;
  color: #15803d;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .14em;
}

.refa-scene h3 {
  margin: 8px 0 0;
  color: #052e2b;
  font-family: 'Sora', sans-serif;
  font-size: 27px;
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: -.06em;
}

.refa-copy {
  margin: 12px 0 0;
  color: #475569;
  font-size: 13.5px;
  line-height: 1.6;
  font-weight: 700;
}

.refa-number-card,
.refa-code-card {
  margin-top: 18px;
  padding: 18px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #dbeafe;
  box-shadow: 0 20px 44px rgba(15,23,42,.07);
}

.refa-number-card small,
.refa-code-card small {
  display: block;
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .1em;
}

.refa-number-card strong {
  display: block;
  margin-top: 7px;
  color: #0f172a;
  font-size: 24px;
  font-weight: 900;
}

.refa-code-card {
  border: 2px dashed #16a34a;
  background: #f0fdf4;
  text-align: center;
  transform-origin: center;
  animation: refaCodePulse 24s linear infinite;
}

.refa-code-card strong {
  display: block;
  margin-top: 9px;
  color: #064e3b;
  font-family: 'Sora', sans-serif;
  font-size: 34px;
  font-weight: 800;
}

.refa-wa-header {
  height: 70px;
  padding: 14px;
  background: #075e54;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 11px;
}

.refa-wa-header.green {
  background: #075e54;
}

.refa-wa-header img {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  object-fit: contain;
  background: #fff;
}

.refa-avatar {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-weight: 900;
}

.refa-wa-header strong {
  display: block;
  font-size: 15px;
  font-weight: 900;
}

.refa-wa-header span {
  display: block;
  margin-top: 3px;
  font-size: 11px;
  font-weight: 700;
  color: rgba(255,255,255,.75);
}

.refa-chat-area {
  position: absolute;
  inset: 110px 0 64px;
  padding: 14px 10px;
  background-image:
    radial-gradient(circle at 12px 12px, rgba(15,118,110,.07) 1px, transparent 1px);
  background-size: 42px 42px;
  overflow: hidden;
}

.refa-chat-area.doctor-chat {
  inset: 110px 0 0;
}

.refa-bubble {
  max-width: 82%;
  padding: 10px 12px;
  margin: 10px 0;
  border-radius: 16px;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 700;
  color: #111827;
  opacity: 0;
  transform: translateY(14px) scale(.97);
  box-shadow: 0 3px 12px rgba(15,23,42,.06);
}

.refa-bubble strong {
  display: block;
  margin-top: 7px;
  color: #064e3b;
  font-size: 17px;
  font-family: 'Sora', sans-serif;
}

.refa-bubble.right {
  margin-left: auto;
  background: #dcf8c6;
  border-top-right-radius: 5px;
}

.refa-bubble.left {
  margin-right: auto;
  background: #fff;
  border-top-left-radius: 5px;
}

.refa-compose {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 64px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 10px 14px;
  background: rgba(239,234,226,.96);
}

.refa-compose span {
  flex: 1;
  height: 38px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  border-radius: 999px;
  background: #fff;
  color: #94a3b8;
  font-size: 13px;
  font-weight: 700;
}

.refa-compose button {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 999px;
  background: #25d366;
  color: #fff;
  font-weight: 900;
}

.share-1 { animation: refaShare1 24s linear infinite; }
.share-2 { animation: refaShare2 24s linear infinite; }
.share-3 { animation: refaShare3 24s linear infinite; }

.doctor-1 { animation: refaDoctor1 24s linear infinite; }
.doctor-2 { animation: refaDoctor2 24s linear infinite; }

.enter-1 { animation: refaEnter1 24s linear infinite; }
.enter-2 { animation: refaEnter2 24s linear infinite; }
.enter-3 { animation: refaEnter3 24s linear infinite; }

.refa-credit-float {
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 26px;
  padding: 16px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #bbf7d0;
  box-shadow: 0 24px 60px rgba(15,23,42,.15);
  opacity: 0;
  transform: translateY(18px) scale(.96);
  animation: refaCreditFloat 24s linear infinite;
}

.refa-credit-float span {
  display: block;
  color: #15803d;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .12em;
}

.refa-credit-float strong {
  display: block;
  margin-top: 6px;
  color: #052e2b;
  font-size: 17px;
  font-weight: 1000;
}

.refa-rings {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
}

.refa-rings span {
  position: absolute;
  width: 180px;
  height: 180px;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,.28);
  opacity: 0;
  animation: refaRing 24s linear infinite;
}

.refa-rings span:nth-child(2) { animation-delay: .6s; }
.refa-rings span:nth-child(3) { animation-delay: 1.2s; }

.refa-final-card {
  position: relative;
  z-index: 2;
  width: calc(100% - 34px);
  padding: 28px 20px;
  border-radius: 32px;
  text-align: center;
  background: rgba(255,255,255,.12);
  border: 1px solid rgba(255,255,255,.22);
  backdrop-filter: blur(14px);
  color: #fff;
}

.refa-final-card img {
  width: 78px;
  height: 78px;
  object-fit: contain;
  border-radius: 24px;
  background: rgba(255,255,255,.9);
  margin-bottom: 18px;
}

.refa-final-card small {
  display: block;
  color: #bbf7d0;
  font-size: 11px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: .12em;
}

.refa-final-card h3 {
  margin: 10px 0 0;
  color: #fff;
  font-family: 'Sora', sans-serif;
  font-size: 31px;
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: -.06em;
}

.refa-final-card p {
  margin: 14px auto 0;
  max-width: 260px;
  color: rgba(255,255,255,.82);
  font-size: 14px;
  line-height: 1.6;
  font-weight: 700;
}

.refa-balance {
  margin-top: 20px;
  padding: 14px 16px;
  border-radius: 22px;
  background: #fff;
  color: #064e3b;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.refa-balance span {
  max-width: 130px;
  text-align: left;
  font-size: 12px;
  line-height: 1.25;
  font-weight: 900;
}

.refa-balance strong {
  font-size: 24px;
  font-weight: 1000;
}

@keyframes refaScene1 {
  0%, 18% { opacity: 1; transform: scale(1); }
  22%, 100% { opacity: 0; transform: scale(1.02); }
}

@keyframes refaScene2 {
  0%, 19% { opacity: 0; transform: translateX(18px); }
  23%, 38% { opacity: 1; transform: translateX(0); }
  42%, 100% { opacity: 0; transform: translateX(-18px); }
}

@keyframes refaScene3 {
  0%, 39% { opacity: 0; transform: translateX(18px); }
  43%, 58% { opacity: 1; transform: translateX(0); }
  62%, 100% { opacity: 0; transform: translateX(-18px); }
}

@keyframes refaScene4 {
  0%, 59% { opacity: 0; transform: translateX(18px); }
  63%, 78% { opacity: 1; transform: translateX(0); }
  82%, 100% { opacity: 0; transform: translateX(-18px); }
}

@keyframes refaScene5 {
  0%, 79% { opacity: 0; transform: scale(1.04); }
  84%, 98% { opacity: 1; transform: scale(1); }
  100% { opacity: 0; transform: scale(1.02); }
}

@keyframes refaCodePulse {
  0%, 8% { transform: scale(.96); opacity: .72; }
  12%, 18% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 8px rgba(34,197,94,.12); }
  22%, 100% { transform: scale(1); }
}

@keyframes refaShare1 {
  0%, 24% { opacity: 0; transform: translateY(14px) scale(.97); }
  27%, 38% { opacity: 1; transform: translateY(0) scale(1); }
  42%, 100% { opacity: 0; }
}

@keyframes refaShare2 {
  0%, 28% { opacity: 0; transform: translateY(14px) scale(.97); }
  31%, 38% { opacity: 1; transform: translateY(0) scale(1); }
  42%, 100% { opacity: 0; }
}

@keyframes refaShare3 {
  0%, 33% { opacity: 0; transform: translateY(14px) scale(.97); }
  36%, 38% { opacity: 1; transform: translateY(0) scale(1); }
  42%, 100% { opacity: 0; }
}

@keyframes refaDoctor1 {
  0%, 44% { opacity: 0; transform: translateY(14px) scale(.97); }
  47%, 58% { opacity: 1; transform: translateY(0) scale(1); }
  62%, 100% { opacity: 0; }
}

@keyframes refaDoctor2 {
  0%, 50% { opacity: 0; transform: translateY(14px) scale(.97); }
  53%, 58% { opacity: 1; transform: translateY(0) scale(1); }
  62%, 100% { opacity: 0; }
}

@keyframes refaEnter1 {
  0%, 64% { opacity: 0; transform: translateY(14px) scale(.97); }
  67%, 78% { opacity: 1; transform: translateY(0) scale(1); }
  82%, 100% { opacity: 0; }
}

@keyframes refaEnter2 {
  0%, 68% { opacity: 0; transform: translateY(14px) scale(.97); }
  71%, 78% { opacity: 1; transform: translateY(0) scale(1); }
  82%, 100% { opacity: 0; }
}

@keyframes refaEnter3 {
  0%, 72% { opacity: 0; transform: translateY(14px) scale(.97); }
  75%, 78% { opacity: 1; transform: translateY(0) scale(1); }
  82%, 100% { opacity: 0; }
}

@keyframes refaCreditFloat {
  0%, 72% { opacity: 0; transform: translateY(18px) scale(.96); }
  76%, 80% { opacity: 1; transform: translateY(0) scale(1); }
  82%, 100% { opacity: 0; transform: translateY(-10px) scale(.98); }
}

@keyframes refaRing {
  0%, 84% { opacity: 0; transform: scale(.4); }
  88% { opacity: .55; transform: scale(.7); }
  100% { opacity: 0; transform: scale(2.5); }
}

@keyframes refaShadow {
  0%, 100% { transform: scaleX(.94); opacity: .62; }
  50% { transform: scaleX(1.06); opacity: .84; }
}

@keyframes refaPhoneFloat {
  0%, 100% { transform: rotateY(-6deg) translateY(0); }
  50% { transform: rotateY(-3deg) translateY(-12px); }
}

@media (max-width: 560px) {
  .refa-stage {
    min-height: 620px;
  }

  .refa-phone {
    width: min(312px, 88vw);
    height: min(624px, calc(88vw * 2));
  }

  .refa-final-card h3 {
    font-size: 28px;
  }
}
`;